import DecimalEditor from "../DecimalEditor";
import Props from "./index.d";

const IntegerEditor = (props: Props) => {
  const integerRegexMax15Characters = "^[0-9]*$";
  const { testId } = props;
  return <DecimalEditor {...props} validationRegex={integerRegexMax15Characters} testId={testId} />;
};

export default IntegerEditor;
